function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9006 0H5.0985C2.0484 0 0 2.1402 0 5.3253V12.6756C0 15.8598 2.0484 18 5.0985 18H12.8997C15.9498 18 18 15.8598 18 12.6756V5.3253C18 2.1402 15.9507 0 12.9006 0Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5124 8.32383H8.38242C8.09442 7.36083 7.21242 6.65883 6.15942 6.65883C4.86342 6.65883 3.81042 7.71183 3.81042 8.99883C3.81042 10.2948 4.86342 11.3388 6.15942 11.3388C7.21242 11.3388 8.09442 10.6368 8.38242 9.67383H10.2904V10.6638C10.2904 11.0418 10.5874 11.3388 10.9654 11.3388C11.3344 11.3388 11.6404 11.0418 11.6404 10.6638V9.67383H12.8374V10.6638C12.8374 11.0418 13.1344 11.3388 13.5124 11.3388C13.8814 11.3388 14.1874 11.0418 14.1874 10.6638V8.99883C14.1874 8.62983 13.8814 8.32383 13.5124 8.32383Z",
  fill: "#FFDD02"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.1594 9.98882C5.6104 9.98882 5.1604 9.54782 5.1604 8.99882C5.1604 8.44982 5.6104 8.00882 6.1594 8.00882C6.6994 8.00882 7.1494 8.44982 7.1494 8.99882C7.1494 9.54782 6.6994 9.98882 6.1594 9.98882Z",
  fill: "#230B34"
});

var SvgPassword = function SvgPassword(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPassword, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Password.e0151311.svg";
export { ForwardRef as ReactComponent };